"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdmefyEvents = void 0;
const campaign_events_1 = require("./entity/campaign.events");
const display_events_1 = require("./entity/display.events");
const event_events_1 = require("./entity/event.events");
const notification_events_1 = require("./entity/notification.events");
const user_events_1 = require("./entity/user.events");
__exportStar(require("./sellers-json-invalidation.event"), exports);
/**
 * Generador de eventos de dominio de Admefy
 */
class AdmefyEvents {
    parts = [];
    constructor() { }
    clean() {
        this.parts = [];
        return this;
    }
    addPart(part) {
        this.parts.push(part);
        return this;
    }
    toString() {
        return this.parts.join(".");
    }
    static get admefy() {
        return new AdmefyEvents().clean().addPart("admefy");
    }
    /**
     * Entidades de eventos
     */
    get campaign() {
        return campaign_events_1.CampaignEvents.campaign(this).addPart("campaign");
    }
    get notification() {
        return notification_events_1.NotificationEvents.notification(this).addPart("notification");
    }
    get user() {
        return user_events_1.UserEvents.user(this).addPart("user");
    }
    get display() {
        return display_events_1.DisplayEvents.display(this).addPart("display");
    }
    get event() {
        return event_events_1.EventEvents.event(this).addPart("event");
    }
    get wildcard() {
        this.parts.push("*");
        return this.toString();
    }
}
exports.AdmefyEvents = AdmefyEvents;
